(() => {
  function initSamteLanding(root) {
    root.querySelectorAll('[data-samte-tabs]').forEach((tabs) => {
      const buttons = tabs.querySelectorAll('[data-tab]');
      const panels = tabs.querySelectorAll('[data-panel]');

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const target = button.getAttribute('data-tab');

          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          panels.forEach((panel) => {
            const active = panel.getAttribute('data-panel') === target;
            panel.classList.toggle('is-active', active);
            panel.hidden = !active;
          });
        });
      });
    });

    const animated = root.querySelectorAll('.fade-up, .stagger-up, .img-reveal');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('samte-is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -10% 0px' });

    animated.forEach((node) => observer.observe(node));

    [
      '.samte-hero-badge',
      '.samte-hero-title',
      '.samte-hero-sub',
      '.samte-hero-desc',
      '.samte-hero-cta',
      '.samte-hero-trust'
    ].forEach((selector, index) => {
      const node = root.querySelector(selector);
      if (!node) return;
      window.setTimeout(() => node.classList.add('samte-is-visible'), 180 + index * 160);
    });

    root.querySelectorAll('[data-samte-quantity-stepper]').forEach((stepper) => {
      if (stepper.dataset.samteQuantityBound === 'true') return;
      stepper.dataset.samteQuantityBound = 'true';

      const input = stepper.querySelector('input[name="quantity"]');
      if (!input) return;

      stepper.querySelectorAll('[data-samte-quantity-change]').forEach((button) => {
        button.addEventListener('click', () => {
          const change = parseInt(button.getAttribute('data-samte-quantity-change'), 10) || 0;
          const min = parseInt(input.getAttribute('min'), 10) || 1;
          const max = parseInt(input.getAttribute('max'), 10);
          const current = parseInt(input.value, 10) || min;
          let next = Math.max(min, current + change);

          if (!Number.isNaN(max)) next = Math.min(max, next);

          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    root.querySelectorAll('.samte-product-form[data-samte-purchase-mode="checkout"]').forEach((form) => {
      if (form.dataset.samteCheckoutBound === 'true') return;
      form.dataset.samteCheckoutBound = 'true';

      form.addEventListener('submit', (event) => {
        const variantInput = form.querySelector('input[name="id"]');
        const quantityInput = form.querySelector('input[name="quantity"]');
        const variantId = variantInput && variantInput.value;
        const quantity = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);

        if (!variantId) return;

        event.preventDefault();
        const rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';
        const normalizedRoot = rootPath.endsWith('/') ? rootPath : `${rootPath}/`;

        window.location.href = `${normalizedRoot}cart/${encodeURIComponent(variantId)}:${quantity}`;
      });
    });
  }

  function boot() {
    document.querySelectorAll('.samte-page-section').forEach(initSamteLanding);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', (event) => initSamteLanding(event.target));
})();
